<div class="bodycontent">
    <div class="subheader with-padding flgrow">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-8" *ngIf="dealers && dealers?.length > 0">
                <div class="relative flmid">
                    <div class="flgrow">
                        <ng-select class="w-100" placeholder="{{ 'lblSelectDealer' | translate }}"
                            [(ngModel)]="dealerId" name="dealerId" (change)="onDealerChange($event)"
                            (keyup.enter)="onSearch()">
                            <ng-option *ngFor="let dealer of dealers"  [value]="dealer.dealerId">
                                {{dealer.name}}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
                <p *ngIf="isRequired" class="help-block text-danger" translate>lblRequiredDealer</p>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-8">
                <div class="relative flmid">
                    <div class="flgrow">
                        <select class="form-control" [(ngModel)]="selecteMechanic"
                            (change)="selectedMechanic($event.target.value)">
                            <option selected [value]="0" disabled translate>lblSelectMechanic</option>
                            <option *ngFor="let mechanic of mechanicList" [(ngValue)]="mechanic.id">
                                {{mechanic.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-auto ml-auto" *ngIf="isMechanicSelected">
                <!-- Excel -->
                <button type="button" (click)="exportAsXLSX()"
                    ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align">
                    <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
                </button> 
                <a class="ml-2 btn btn-outline-primary" 
                    (click)="onRefresh()" aria-label="Center Align">
                    <em class="fas fa-sync fa-lg"></em>
                </a>
            </div>
        </div>
    </div>
    <div class="container prel" *ngIf="isMechanicSelected">
        <div class="card" *ngIf="mechanicData?.length > 0;else load_else">
            <div class="card-body pb-0">
                <ng-container>
                    <app-af-mechanic-scheduler-list [schedularHeader]="schedulerHeaderInfo"
                        (onMonthChange)="scheduleSummaryMonthChange($event)" [isScheduleSummary]="true"
                        [dealerName]="dealerName" [selectedDate]="selectedDate" [mechanicData]="mechanicData">
                    </app-af-mechanic-scheduler-list>
                </ng-container>
            </div>
        </div>
        <ng-template #load_else>
            <div class="card" *ngIf="isMechanicNotAssociated">
                <div class="card-body pb-0">
                    <ng-container>
                        <div class="alert alert-danger text-center mx-3">
                            <span class="font18">
                                {{'lblSetMechanicShift'|translate}}
                            </span>
                        </div>

                    </ng-container>
                </div>
            </div>
        </ng-template>
        <ng-container *ngIf="isSearched && mechanicData.length > 0">
            <ul class="list-inline mt-3 d-flex justify-content-end">
                <li class="list-inline-item align-items-center ">
                    <strong class="color-bg align-middle" style="background-color: #bee7ac"></strong>
                    <span class="align-middle" translate>lblMechanicAvailable</span>
                </li>

                <li class="list-inline-item align-items-center ml-3">
                    <strong class="color-bg align-middle" style="background-color: #bfc2b7"></strong>
                    <span class="align-middle" translate>lblMechanicisNotAvailable</span>
                </li>
            </ul>
        </ng-container>
    </div>
</div>